<template>
  <div>
    <CTopMenu
      :menuList="menuList"
      svgPath="WaveForming.svg"
      svgWidth="12vw"
      svgMargin="0 0 1vh 0.5vw"
      :user="user"
    ></CTopMenu>
    <div style="height: 94vh">
      <router-view/>
    </div>
  </div>
</template>

<script>
import CTopMenu from "@/lib/tui/template/menu/CTopMenu.vue";
export default {
  name: "CMainPage",
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  components: {
    CTopMenu
  },
  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
  created: function () {
    document.title = "WaveForming Tools";
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  props: {
    user: Object
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  data () {
    return {
      menuList: [
        { id: "home", label: "Home" },
        { id: "room", label: "Subwoofers" },
        { id: "measures", label: "Measurements" }
      ]
    }
  }
}
</script>